import { applicationParameters } from '../utilities/application-parameters';

export const useIdempotencyKey = (): string => {
  return applicationParameters.get('trackingId') || 'UNDEFINED_TRACKING_ID';
};
